import React from 'react'
import CarouselApp from './CarouselApp'

export default function Modal({screenshots, setModalOpen}) {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-30 backdrop-blur-sm flex justify-center items-center max-h-content mx-auto z-20" onClick={() => setModalOpen(false)}>
            <div className="p-2 flex max-w-[80%] sm:max-w-4xl rounded-lg overflow-y-auto max-h-content justify-end" onClick={e => e.stopPropagation()}>
                <CarouselApp screenshots={screenshots} setModalOpen={setModalOpen} />
                {/* <button className="border rounded-md py-2 px-3 shadow appearance-none font-semibold text-white  md:max-w-xs active:scale-90 block fixed items-center" onClick={() => setModalOpen(false)}>Close</button> */}
            </div>
        </div>
  )
}
